import {SegmentedControl} from '@primer/react'
import {use} from 'react'
import {CommentsFilter} from './CommentsFilter'
import {CommentsContext, ViewMode} from './CommentsContext'
import type {AuthorFilterItem} from './utils/get-author-filters'
import type {CommentsFilterState} from './use-comments-filter-state'

export function isReviewCommentsViewMode(viewMode: ViewMode): boolean {
  return viewMode === ViewMode.ThreadPreviews
}

interface CommentsViewControlsProps {
  /** All authors in the current view mode. */
  authorList: AuthorFilterItem[]
  /** Current filter state, for the current view mode. */
  filterState: CommentsFilterState
  setFilterState: (state: CommentsFilterState) => void
  iconOnly?: boolean
}

/**
 * Renders view controls (filter, sort, etc) for comments.
 */
export function CommentsViewControls({authorList, filterState, setFilterState, iconOnly}: CommentsViewControlsProps) {
  const {viewMode, setViewMode} = use(CommentsContext)
  const isReviewCommentsMode = isReviewCommentsViewMode(viewMode)

  // Review and conversation each keep their own filter state.
  return (
    <div className="d-flex flex-row flex-items-center gap-2 py-2">
      <SegmentedControl
        aria-label="Comment view mode"
        onChange={(value: number) => {
          const nextViewMode = value === 0 ? ViewMode.ThreadPreviews : ViewMode.IssueComments
          setViewMode(nextViewMode)
        }}
      >
        <SegmentedControl.Button selected={isReviewCommentsMode}>Review</SegmentedControl.Button>
        <SegmentedControl.Button selected={viewMode === ViewMode.IssueComments}>Conversation</SegmentedControl.Button>
      </SegmentedControl>
      <CommentsFilter
        authorList={authorList}
        className="width-full"
        filterState={filterState}
        onFilterStateChange={setFilterState}
        hideReviewThreadFilters={!isReviewCommentsMode}
        iconOnly={iconOnly}
      />
    </div>
  )
}
